import gql from "graphql-tag";

const signIn = gql`
  mutation(
    $username: String
    $email: String
    $password: String!
    $remember: Boolean
  ) {
    signIn(
      data: {
        username: $username
        email: $email
        password: $password
        remember: $remember
      }
    ) {
      token
      user {
        id
        username
        fullname
        email
        employeeId
      }
    }
  }
`;

export default { signIn };
